import { themeGet } from '@magalu/stereo-ui-styles';
import styled from 'styled-components';
import { margin } from 'styled-system';
import Box from '../../atoms/Box';
import Link from '../../atoms/Link';
export const Container = styled(Box).attrs(() => ({
  backgroundColor: 'background.base',
  paddingBottom: 5
}))``;
export const Content = styled.nav`
  ${margin}
  padding: 0 ${props => themeGet('space.2')(props)}px;
`;
export const LogoutLink = styled(Link).attrs(() => ({
  backgroundColor: 'primary.base',
  color: 'text.lightest',
  paddingTop: 3,
  paddingBottom: 5,
  marginBottom: -5
}))``;
export const Subtitle = styled.small`
  font-family: ${themeGet('fontFamily')};
  display: block;
  margin: ${props => themeGet('space.1')(props)}px
    ${props => themeGet('space.2')(props)}px;
`;
export const IconsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(30px, max-content));
  justify-content: center;
  grid-gap: ${props => themeGet('space.4')(props)}px;
`;
export const SalesChannels = styled.div`
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const SaleChannel = styled.p`
  svg {
    margin-right: 2px;
  }
  display: flex;
  align-items: center;
`;
export const LinkContainer = styled.div`
  padding: 10px 16px;
`;